// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"bulkEmailInvite__gradient-bg5__YLlfM","component":"bulkEmailInvite__component__BN5uk"};